export class PayrollCalendarViewPlusDto {
  id: string;

  name: string;

  description: string | null;
}
